document.addEventListener("DOMContentLoaded", function () {
  openExternalLinksInNewTab();
  videoSlideShowSlide();

  //product description get detailes btn click event
  let getDetailesBtn = document.querySelector(
    '.product .product__description a[title="Get the Details"]',
  );
  if (getDetailesBtn) {
    getDetailesBtn.addEventListener("click", function (e) {
      e.preventDefault();
      let descAccordionBtn = document.querySelectorAll(
        ".product .data-description",
      );
      if (descAccordionBtn.length) {
        descAccordionBtn.forEach((el) => {
          el.scrollIntoView({ behavior: "smooth" });
          if (el.querySelector('button[aria-expanded="false"]')) {
            el.querySelector('button[aria-expanded="false"]').click();
          }
        });
      }
    });
  }

  //outside click event
  document.onclick = function (e) {
    //close all country selector dropdown
    if (!e.target.closest("[data-country-selector-ele]")) {
      if (
        document.querySelectorAll(".footer [data-country-selector-ele]").length
      ) {
        document
          .querySelectorAll(".footer [data-country-selector-ele]")
          .forEach((country) => country.classList.remove("active"));
      }
    }
  };

  //get product description all images alt text and adding seprate div ele for showing that alt text on img hover
  var description_imgs = document.querySelectorAll(
    ".product .accordion.data-description img",
  );
  if (description_imgs.length) {
    for (let i = 0; i < description_imgs.length; i++) {
      if (description_imgs[i]) {
        const get_alt_text = description_imgs[i].getAttribute("alt");
        if (get_alt_text) {
          const tempDiv = document.createElement("div");
          tempDiv.classList.add("img-hover-desc");
          tempDiv.innerHTML = get_alt_text;
          description_imgs[i].insertAdjacentElement("afterend", tempDiv);
        }
      }
    }
  }

  //footer country redirect dropdown
  const footerCountrySelector = document.querySelectorAll(
    ".footer [data-country-selector-ele]",
  );
  if (footerCountrySelector.length) {
    footerCountrySelector.forEach((country) => {
      if (country.querySelector("[data-select-ele]")) {
        country
          .querySelector("[data-select-ele]")
          .addEventListener("click", function (e) {
            e.preventDefault();
            e.target
              .closest("[data-country-selector-ele]")
              .classList.toggle("active");
          });
      }
    });
  }
});

// Open links to other sites in a new tab, except the footer country selector
function openExternalLinksInNewTab() {
  document.querySelectorAll("a").forEach((link) => {
    if (
      link.hostname &&
      link.hostname !== window.location.hostname &&
      (link.protocol === "http:" || link.protocol === "https:") &&
      !link.closest("[data-country-selector-ele]")
    ) {
      link.setAttribute("target", "_blank");
      link.relList.add("noopener");
    }
  });
}

function videoSlideShowSlide() {
  const mobileQuery = window.matchMedia("(max-width: 719px)");
  const video_slide_selectors = document.querySelectorAll(
    `.slideshow .video-hero__media-container`,
  );
  if (!video_slide_selectors.length) return;
  let index = 1;

  video_slide_selectors.forEach((video_slide) => {
    const hasVideo = video_slide.dataset.hasVideo === "true";
    const hasMobileVideo = video_slide.dataset.hasMobileVideo === "true";

    const videoDefaultTemplate = video_slide.querySelectorAll(
      "#default-video-template",
    );
    const videoMobileTemplate = video_slide.querySelectorAll(
      "#mobile-video-template",
    );
    const currentVideoContainer = video_slide.querySelectorAll(
      ".current-video-container",
    );

    if (hasMobileVideo) {
      if (mobileQuery.matches) {
        _updateVideoTemplate(videoMobileTemplate, currentVideoContainer, index);
      } else {
        _updateVideoTemplate(
          videoDefaultTemplate,
          currentVideoContainer,
          index,
        );
      }

      // Add listeners for changes in the media queries
      mobileQuery.addListener(function () {
        if (mobileQuery.matches) {
          _updateVideoTemplate(
            videoMobileTemplate,
            currentVideoContainer,
            index,
          );
        } else {
          _updateVideoTemplate(
            videoDefaultTemplate,
            currentVideoContainer,
            index,
          );
        }
      });
    } else if (hasVideo) {
      _updateVideoTemplate(videoDefaultTemplate, currentVideoContainer, index);
    }
    index += 1;
  });
}

function _updateVideoTemplate(videoTemplate, container, slideIndex) {
  container.forEach((container) => (container.innerHTML = ""));

  for (let i = 0; i < videoTemplate.length; i++) {
    const content = document.createElement("div");
    content.appendChild(
      videoTemplate[i].content.firstElementChild.cloneNode(true),
    );
    const deferredElement = container[i].appendChild(
      content.querySelector("video"),
    );

    if (
      deferredElement.nodeName == "VIDEO" &&
      deferredElement.getAttribute("autoplay")
    ) {
      // force autoplay for safari
      deferredElement.muted = true;
      if (slideIndex === 1) setTimeout(() => deferredElement.play(), 150);
    }
  }
}

function slideDownEle(element) {
  content = element.parentElement.querySelector("[data-content]");
  var openClass = "slide--open";
  if (content && !content.classList.contains(openClass)) {
    content.classList.add(openClass);
    element.classList.add(openClass);
    content.style.maxHeight = content.scrollHeight + "px";
  }
}

function slideUpEle(element) {
  content = element.closest("[data-content]");
  var openClass = "slide--open";
  if (content && content.classList.contains(openClass)) {
    content.classList.remove(openClass);
    setTimeout(
      () =>
        element
          .closest(".verified-meta-desc")
          .querySelector(".expand_link")
          .classList.remove(openClass),
      300,
    );
    content.style.maxHeight = "0px";
  }
}
